module.exports = __webpack_public_path__ + "static/media/EW-module-banner.353a0982.svg";